import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { initSentry, sentryPiniaPlugin } from './sentry'
import { useAuthStore } from './stores/auth'
import { expand, getStartParam, isInsideTelegram, ready, startParamToRoute } from './telegramWebApp'

const app = createApp(App)

initSentry(app, router)

const pinia = createPinia()
pinia.use(sentryPiniaPlugin())
app.use(pinia)
app.use(router)

// Opened as the Telegram Mini App: log in with the signed initData (the Login Widget does not work in there),
// then follow a `startapp` link (control link / session) if there is one. Failing is fine, the login page offers a retry.
async function startInsideTelegram() {
  ready()
  expand()
  const auth = useAuthStore()
  if (!auth.hasValidToken) {
    // The refresh token first, then the initData (what `recover()` does).
    await auth.recover()
  }
  const target = startParamToRoute(getStartParam())
  if (target) await router.replace(target)
}

void (async () => {
  if (isInsideTelegram()) await startInsideTelegram()
  app.mount('#app')
})()

document.title = import.meta.env.VITE_APP_TITLE || 'Cum Time'
